import PropTypes from 'prop-types';
import AgendaList from '../../../agendaList';

const Agenda = ({ translations, moderatorAgenda, employeeAgenda = [] }) => {
  return (
    <>
      <AgendaList
        title={translations.managerAgenda}
        items={moderatorAgenda}
        showNoResults
      />
      <div>
        <AgendaList
          title={translations.employeeAgenda}
          items={employeeAgenda}
        />
      </div>
    </>
  );
};

Agenda.propTypes = {
  translations: PropTypes.object.isRequired,
  moderatorAgenda: PropTypes.arrayOf(PropTypes.object).isRequired,
  employeeAgenda: PropTypes.arrayOf(PropTypes.object),
};

export default Agenda;
